import convertUnitMoney from './convertUnitMoney';

//takes an array of income per unit and returns the total rent income
const getTotalRentIncome = (grossIncomePerUnit) => {
  if (grossIncomePerUnit && grossIncomePerUnit.length > 0) {
    const allUnitRentIncome = grossIncomePerUnit.reduce((acc, unit) => {
      const unitRent = unit.rent;
      const unitRentIncome = convertUnitMoney(unitRent);
      return unitRentIncome ? acc + unitRentIncome : acc;
    }, 0);
    return allUnitRentIncome;
  }
  return null;
};

export default getTotalRentIncome;
